export const translations = {
  "Incorrect username or password.": "Datos incorrectos, vuelve a intentarlo",
  "User does not exist.": "Datos incorrectos, vuelve a intentarlo",
  "User already exists": "El usuario ya está registrado",
  "Invalid verification code provided, please try again.":
    "Codigo de verificacion invalido, intenta nuevamente",
  "Username/client id combination not found.": "Usuario no encontrado",
  "patient added successfully": "paciente agregado correctamente",
  "patient update successfully": "paciente actualizado correctamente",
  ACTIVE: "ACTIVADO",
  "admin update successfully": "datos actualizados correctamente",
  "Attempt limit exceeded, please try after some time.":
    "Número de intentos excedido, intenta más tarde",
  "doctor added successfully": "doctor agregado correctamente",
  "doctor update successfully": "doctor actualizado correctamente",
  "Sent email succesfully": "Encuesta enviada correctamente",
  "surgeryRoom added successfully":
    "Sala de procedimiento agregada correctamente",
  "surgeryRoom update successfully":
    "Sala de procedimiento actualizada correctamente",
  "surgeryRooms not found": "Salas de procedimiento no encontradas",
  "doctors not found": "Doctores no encontrados",
  rapido: "bajo",
  lento: "alto",
  "patientSurgeries not found":
    "No existe historial de valoraciones para este usuario",
  "forbidden cancel valoration before 24 hours":
    "No puedes cancelar tu valoración antes de 24 horas",
  "forbidden cancel procedure before 24 hours":
    "No puedes cancelar tu procedimiento antes de 24 horas",
  "You cannot create events in the past":
    "No puedes crear eventos en el pasado",
  "The start time must be earlier than the end time":
    "La fecha inicial no debe ser mayor a la fecha final",
  "You cannot update events in the past":
    "No puedes actualizar eventos del pasado",
  "You cannot update events back in time":
    "No puedes actualizar eventos hacia el pasado",
  "An event is already scheduled for today":
    "No puedes agendar más de una sesión para el mismo día",
  "patients not found": "Pacientes no encontrados",
  "scheduleEvent added successfully": "Evento agregado correctamente",
  "scheduleEvent updated successfully": "Evento actualizado correctamente",
  "patientSurgery update successfully": "Valoración actualizada correctamente",
  "FAST TRACK": "bajo",
  "Fast Track": "bajo",
  "SLOW TRACK": "alto",
  "Slow Track": "alto",
  "workShift added successfully": "Jornada agregada correctamente",
  "workShifts not found": "Jornadas no encontradas",
  "shiftProcedure added successfully": "Procedimiento agregado correctamente",
  "shiftProcedures not found": "Procedimientos no encontrados",
  "patientSurgeriesWithClearance not found": "No hay pacientes por agendar",
  "patientSurgeriesWithoutClearance not found":
    "No hay pacientes sin autorizacion",
  "scheduleEvents not found": "Eventos no encontrados",
  "profile updated successfully": "Perfil actualizado correctamente",
  "dailyAssessmentEvents not found": "Consultas no encontradas",
  "scheduleEvent canceled successfully": "Evento cancelado correctamente",
  "scheduleEvent update successfully": "Evento actualizado correctamente",
  "patientSurgeryByTrack not found": "No se encontraron registros",
  "questionSatisfaction not found": "No se encontraron registros",
  "file uploaded successfully": "Archivo subido correctamente",
  "chartPatientSurgeryByAssessmentMade not found":
    "No se encontraron registros",
  "Bulk upload completed": "Registro masivo completo",
  // Agrega más traducciones según sea necesario
};
